import React, { Fragment } from 'react';

export default function Text(): JSX.Element {
  return (
    <Fragment>
      <div className='text-slate-800 text-lg not-italic font-semibold leading-7 my-2'>
        Frequently Asked Questions
      </div>
      <div>
        If you have any questions please feel free to give us a call at{' '}
        <span className='text-blue-600'>
          <a href='tel:276.531.9260'>276.531.9260</a>
        </span>{' '}
        or email us directly at{' '}
        <span className='text-blue-600'>
          <a href='mailto:support@snap-raise.com'>support@snap-raise.com</a>
        </span>
        .
      </div>
    </Fragment>
  );
}
